const MuiTable = {
  styleOverrides: {
    root: {
      minWidth: 'fit-content',
      overflowX: 'auto',
      '::-webkit-scrollbar': { display: 'none' },
    },
  },
};

export default MuiTable;
